export const _ = undefined;
export const V = 'V', H = 'H', L = 'L', Z = 'Z', M = 'M', C = 'C', S = 'S', Q = 'Q', T = 'T', A = 'A';
export const EMPTY = ' ';
export const FILL = 'fill';
export const NONE = 'none';
